import { Injectable } from '@angular/core';
import { FateIconService } from 'fate-editor';

@Injectable()
export class CustomIconService extends FateIconService {
  protected iconMapping: any = {
    'c-bold': '<i class="material-icons" title="Bold">format_bold</i>',
    'c-italic': '<i class="material-icons" title="Italics">format_italic</i>',
    'c-underline': '<i class="material-icons" title="Underline">format_underlined</i>',
    'smallcaps': '<i class="material-icons" title="Smallcaps">title</i>',
    'note': '<i class="material-icons" title="Note">superscript</i>',
    'glos-concept': '<i class="material-icons glos-icon-concept" title="Concetto">fiber_manual_record</i>',
    'glos-linguistic': '<i class="material-icons glos-icon-linguistic" title="Linguistica">fiber_manual_record</i>',
    'glos-idiom': '<i class="material-icons glos-icon-idiom" title="Espr. idiomatica">fiber_manual_record</i>',
    'glos-rabbi': '<i class="material-icons glos-icon-rabbi" title="Rabbino">fiber_manual_record</i>',
    'glos-nature': '<i class="material-icons glos-icon-nature" title="Natura">fiber_manual_record</i>',
    'glos-name': '<i class="material-icons glos-icon-name" title="Nome">fiber_manual_record</i>',
    'glos-daily': '<i class="material-icons glos-icon-daily" title="Vita quotidiana">fiber_manual_record</i>',
    'clean': '<i class="material-icons" title="Remove formatting">format_clear</i>',
    'undo': '<i class="material-icons" title="Undo">undo</i>',
    'redo': '<i class="material-icons" title="Redo">redo</i>',
    'special-char': '<i title="Special characters"><img src="../../../../assets/img/specialChars.png"></i>',
    'accented-char': '<i title="Accented characters"><img src="../../../../assets/img/accentedChars.png"></i>',
    'bible': '<i title="Bible"><img src="../../../../assets/img/bibleQuote.png"></i>',
    'legal-code': '<i title="Legal code"><img src="../../../../assets/img/legalCodeQuote.png"></i>',
    'mishna': '<i title="Mishnà"><img src="../../../../assets/img/mishnaQuote.png"></i>',
    'talmud-bavli': '<i title="Talmud Bavlì"><img src="../../../../assets/img/talmudBavliQuote.png"></i>',
    'talmud-yerushalmi': '<i title="Talmud Yerushalmi"><img src="../../../../assets/img/talmudYerushalmiQuote.png"></i>',
    'tosefta': '<i title="Toseftà"><img src="../../../../assets/img/toseftaQuote.png"></i>',
    'view-code': '<i class="material-icons" title="Show source">code</i>',
    'strike': '<i class="material-icons" title="Strikethrough">format_strikethrough</i>',
    'subscript': '<i class="material-icons" title="Subscript">subscript</i>',
    'superscript': '<i class="material-icons" title="Superscript">superscript</i>',
    'indent': '<i class="material-icons" title="Indent">format_indent_increase</i>',
    'outdent': '<i class="material-icons" title="Outdent">format_indent_decrease</i>',
    'ordered': '<i class="material-icons" title="Outdent">format_list_numbered</i>',
    'unordered': '<i class="material-icons" title="Outdent">format_list_bulleted</i>',
    'center': '<i class="material-icons" title="Align Text Center">format_align_center</i>',
    'justify': '<i class="material-icons" title="Justify">format_align_justify</i>',
    'left': '<i class="material-icons" title="Align Text Left">format_align_left</i>',
    'right': '<i class="material-icons" title="Align Text Right">format_align_right</i>',
    'horizontal-rule': '<i class="material-icons" title="Insert Horizontal Rule">horizontal_rule</i>',
    'link': '<i class="material-icons" title="Insert Link">insert_link</i>',
    'image': '<i class="material-icons" title="Insert Image">insert_photo</i>',
    'font': '<i class="material-icons" title="Font">title</i>',
    'font-style': '<i class="material-icons" title="Font Style">font_download</i>',
    'font-size': '<i class="material-icons" title="Font Size">format_size</i>',
    'font-color': '<i class="material-icons" title="Font Color">palette</i>',
    'font-highlight': '<i class="material-icons" title="Text Highlight Color">highlight</i>'
  };

  public getIcon(actionName): string {
    return this.iconMapping[actionName];
  }
}